<template>
  <div class="LmLandscapeSelector">
    <ul class="Landscapes">
      <lm-landscape
        v-for="landscape in landscapes"
        :key="landscape.slug"
        :landscape="landscape"
        :selected="selectedLandscape && selectedLandscape._id === landscape._id"
        @select="select(landscape)"
      />
    </ul>

    <div v-if="selectedLandscape && userList.length > 0" class="UserSection">
      <p class="Info">
        You can choose an additional participant for
        <span class="highlight">{{ selectedLandscape.name }}</span>
      </p>
      <lm-user-selector
        v-model="selectedUser"
        :user-list="userList"
        label="username"
        placeholder="Pick one user"
        max-height="165px"
      />
    </div>
    <span ref="eScroll" />
  </div>
</template>
<script>
import {mapGetters} from 'vuex'
import LmUserSelector from '@/components/form/LmUserSelector'
import LmLandscape from '@/components/modals/freePlan/LmLandscape'

export default {
  name: 'LmLandscapeSelector',
  components: {
    LmLandscape,
    LmUserSelector
  },
  props: {
    landscapes: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      selectedLandscape: null,
      selectedUser: null
    }
  },
  computed: {
    ...mapGetters(['userId']),
    userList() {
      if (this.selectedLandscape) {
        return this.selectedLandscape.users.filter(
          user => user._id !== this.userId
        )
      }
      return []
    }
  },
  methods: {
    select(landscape) {
      this.selectedLandscape = landscape
      this.$emit('landscape-selected')
      this.$nextTick(() => {
        const selector = this.$refs.eScroll
        selector.scrollIntoView({behavior: 'smooth'})
      })
    },
    reset() {
      this.selectedLandscape = null
      this.selectedUser = null
    }
  }
}
</script>
<style scoped>
.LmLandscapeSelector {
  .Title {
    margin: 50px 0 30px;
    font-size: 20px;
  }
  .Landscapes {
    display: flex;
    flex-wrap: wrap;
    margin: 0;
    padding: 0;
  }
  .UserSection {
    margin-bottom: 30px;
    .Info {
      margin-bottom: 30px;
      .highlight {
        color: #0088ff;
      }
    }
  }
}
</style>
